<template>
  <div id="modal">
    <mu-dialog :open="true" title="修改手机号" scrollable dialogClass = 'cellphone-edit-dialog' @show='onDialogShow' bodyClass = 'cellphone-edit-dialog-body'>
      <mu-row>
        <mu-flexbox orient="vertical">
          <mu-flexbox-item>
            <mu-text-field label="当前手机号" v-model="oldMobile" disabled
            v-validate="'required|phone'" name="当前手机号"  />
          </mu-flexbox-item>
          <mu-flexbox-item>
            <mu-text-field label="新手机号" v-model="newMobile" :errorText="newPError"
            v-validate="'required|phone'" name="新手机号" :maxLength="11" />
          </mu-flexbox-item>
          <mu-flexbox-item style="position:relative">
            <mu-text-field label="验证码" v-model="valiCode" :errorText="codeError"
            v-validate="'required|numeric'" name="验证码" :maxLength="6" @keydown="clearInfo(2)" />
            <mu-raised-button  label="获取验证码" @click="getCode" primary @focus="post_success=false" />
            <span v-show="post_success" class="post-code">短信发送成功</span>
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-row>
      <mu-raised-button label="取消" @click="$emit('close')" class="btn-style" style="color:#999;margin-left:20px;" slot="actions" />
      <mu-raised-button  label="提交" @click="submitData" class="btn-style" slot="actions" primary />
    </mu-dialog>
  </div>
</template>
<script>
  import Vue from 'vue'

  export default ({
    props: ['mobile'],
    data() {
      return {
        oldMobile: '',
        newMobile: '',
        valiCode: '',
        errorOld: '',
        errorNew: '',
        errorCode: '',
        isNewMobile:/^[1][3,4,5,7,8][0-9]{9}$/,
        post_success:false,
      }
    },
    computed:{
      newPError: function(){
        if(this.errorNew){
          return this.errorNew;
        } else {
          return this.errors.first('新手机号');
        }
      },
      codeError: function(){
        if(this.errorCode){
          return this.errorCode;
        } else {
          return this.errors.first('验证码');
        }
      },
    },
    mounted: function()
    {
      this.oldMobile = this.mobile
      this.onDialogShow();
    },
    methods: {
      onDialogShow: function(ev)
      {
        try
        {
          let dialogDiv = $('div.cellphone-edit-dialog');
          dialogDiv.css('min-height', dialogDiv.height());
          dialogDiv = $('div.cellphone-edit-dialog-body');
          dialogDiv.css('min-height', dialogDiv.height());
        }
        catch(ex)
        {
          console.log(ex);
        }
      },
      submitData: function(){
        this.post_success = false;
        var self = this;
        this.$validator.validateAll()
          .then(function(isValid) {
            if(false == isValid){
              return false;
            }
            self.$http.post('/api/Auth/changePhone',{
              cur_phone:self.oldMobile,
              new_phone:self.newMobile,
              code: self.valiCode
            },{emulateJSON: true})
              .then(
                function(){
                  self.$emit('submitData',self.oldMobile, self.newMobile)
                },
                function(res){
                  self.errorNew = '';
                  self.errorCode = '';
                }
              )
          })
      },
      // 获取验证码
      getCode: function(){
        var self = this;
        if(this.isNewMobile.test(this.newMobile)===false ){
          this.errorCode = ""
          return this.errorNew = '手机号格式有误'
        }else if(this.newMobile == this.oldMobile){
          this.errorCode = ""
          return this.errorNew = "新旧手机号相同"
        }else{
          self.$http.get(
          '/api/Auth/smsCode',{
            params:{
              username: this.newMobile,
              c:'cphone'
            }
          }).then(
            function(res){
             if(res.body.resultMsg != null){
                self.post_success = true;
             }else{
                self.errorCode = "短信发送成功"
             }
            },
             function(res){
                if(res.body.resultMsg !=null){
                  self.errorCode = ' ';
                  self.errorNew = res.body.resultMsg;
                }else{
                  self.errorNew = "手机号码已存在"
                }
               }
            )
        }
      },
      // 清空后台给出的提示信息
      clearInfo:function(res){
        if(res == 1){
          this.errorMobile = '';
        } else if(res == 2){
          this.errorCode = '';
        }
      }
    }
  })
</script>
<style lang="stylus" scoped>
  @import "../../../assets/css/app.styl"
  .cellphone-edit-dialog
    background #FFF
  .cellphone-edit-dialog-body
    background #FFF
  .post-code
    position absolute
    left 0
    bottom 0
    color #2196f3
    font-size 12px
</style>



// WEBPACK FOOTER //
// mobileChange.vue?20dce748